import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MapActionService {
  readonly zoomRequest = signal(0);

  zoomToContent() {
    const nextId = this.zoomRequest() + 1;
    this.zoomRequest.set(nextId);
  }
}
